import { Brand, getBrand, Product } from "@cerberus/branding";
import { getRunConfig } from "../config/runtimeConfig";

/**
 * Resolve the active brand outside of React (utilities, module-level code,
 * pre-render bootstrap). The brand is fixed for the lifetime of the deployment,
 * so it's safe to read once. React components should prefer `useBranding()`.
 */
export function getActiveBrand(): Brand {
  return getBrand(getRunConfig().brand);
}

/**
 * Is this deployment the given product (or one of them)? For code outside React; components should
 * use `useIsProduct()`. Branch on this rather than on the brand key — two keys are CerebraLinked.
 */
export function isActiveProduct(product: Product | Product[]): boolean {
  const active = getActiveBrand().product;
  return Array.isArray(product) ? product.includes(active) : active === product;
}
